module.exports = __webpack_public_path__ + "odinstatic/media/placement.540e67d3.svg";